import { Suspense, useEffect } from 'react'
import { Canvas, useThree } from '@react-three/fiber'
import { Environment, Float, Lightformer, Stars } from '@react-three/drei'
import { useSnapshot } from 'valtio'

import { state } from './store'
import { PostEffects, GradientBackground, CameraAnimation } from './components/Effects'
import MouseModel1 from './components/MouseModel1'
import { useWindowSize } from './hooks'

function ResponsiveCamera() {
  const { camera } = useThree()
  const { width } = useWindowSize()

  useEffect(() => {
    // FOV: katta = model kichik ko'rinadi
    const fov = width > 1024 ? 25 : width > 768 ? 32 : 40
    camera.fov = fov
    camera.updateProjectionMatrix()
  }, [width, camera])

  return null
}

export default function Scene() {
  const { selectedColor } = useSnapshot(state)

  return (
    <Canvas
      camera={{ position: [0, 0, 5], fov: 25 }}
      dpr={[1, 1.5]}
      performance={{ min: 0.5 }}
    >
      <color attach="background" args={['#0a0a1a']} />
      <fog attach="fog" args={['#0a0a1a', 25, 80]} />
      <GradientBackground />
      <ResponsiveCamera />

      <Suspense fallback={null}>
        <Float speed={1.2} rotationIntensity={0.6} floatIntensity={0.2}>
          <MouseModel1 transitionColor={selectedColor} scale={4} position={[0, 0, 0.18]} />
        </Float>

        {/* Simplified lights for better performance */}
        <directionalLight position={[5, 10, 5]} intensity={2.5} color="#ffffff" />
        <directionalLight position={[-5, 5, -5]} intensity={1} color="#48dbfb" />
        <pointLight position={[0, 3, 2]} intensity={2} color="#ff6b6b" distance={15} />

        {/* Environment - reduced resolution */}
        <Environment resolution={256}>
          <Lightformer intensity={4} rotation-y={Math.PI / 2} position={[-50, 2, 0]} scale={[100, 2, 1]} color="#48dbfb" />
          <Lightformer intensity={3} rotation-y={-Math.PI / 2} position={[50, 2, 0]} scale={[100, 2, 1]} color="#ff9ff3" />
        </Environment>

        <ambientLight intensity={0.4} />

        {/* Stars */}
        <Stars radius={80} depth={50} count={30} factor={3} saturation={0.5} fade speed={0.5} />

        <PostEffects />
        <CameraAnimation />
      </Suspense>
    </Canvas>
  )
}
